interface IDataUsageThreshold {
  label: string;
  value: string;
}

enum WIFI_STATUSES {
  DISABLED = 1,
  THROTTLED,
  ENABLED,
}

type WifiStatusType = { [key in WIFI_STATUSES]: string; };

const WIFI_STATUS_MAPPING: WifiStatusType = {
  [WIFI_STATUSES.DISABLED]: $localize`Disabled`,
  [WIFI_STATUSES.THROTTLED]: $localize`Throttled`,
  [WIFI_STATUSES.ENABLED]: $localize`Enabled`,
};

const WIFI_THRESHOLD_TEXT: string = $localize`Threshold to throttle WiFi hotspot per vehicle`;
const WIFI_THRESHOLD_TEXT_CAPITAL: string = $localize`Threshold to Throttle Wifi Hotspot Per Vehicle`;
const DATA_USAGE_THRESHOLDS: number[] = [ 50, 75, 95, 100 ];

export {
  WIFI_STATUSES,
  WifiStatusType,
  WIFI_STATUS_MAPPING,
  DATA_USAGE_THRESHOLDS,
  WIFI_THRESHOLD_TEXT,
  WIFI_THRESHOLD_TEXT_CAPITAL,
};